var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCarbonAvoidanceLogo = function SvgCarbonAvoidanceLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CBCBCB",
    d: "M17.43 27.84c-3.378-3.29-5.35-7.866-5.361-12.617v-2.724c0-.153.12-.283.283-.283h3.683a.28.28 0 0 0 .207-.469L9.27 4.087A.26.26 0 0 0 9.062 4a.3.3 0 0 0-.207.087l-6.963 7.671c-.163.174-.033.469.207.469h3.683c.152 0 .283.12.283.283v2.713c0 6.581 4.838 12.062 11.136 13.097h.044c.24 0 .36-.305.174-.48z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E1E1E1",
    d: "M17.201 28.32h.044c.24 0 .36-.305.174-.48 0 0-9.022-2.091-11.365-13.957v1.33c0 6.58 4.838 12.061 11.136 13.096z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#8D8D8E",
    d: "M14.934 4.48c3.378 3.29 5.35 7.866 5.36 12.617v2.724c0 .153-.12.283-.282.283h-3.683a.28.28 0 0 0-.207.469l6.962 7.66c.055.065.13.087.207.087a.3.3 0 0 0 .207-.087l6.963-7.66c.163-.174.033-.469-.207-.469H26.56a.28.28 0 0 1-.283-.283v-2.713C26.287 10.516 21.45 5.035 15.152 4h-.044c-.24 0-.36.305-.174.48"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ABABAB",
    d: "M15.152 4h-.044c-.24 0-.36.305-.174.48 0 0 9.022 2.091 11.365 13.957v-1.329C26.288 10.516 21.449 5.035 15.152 4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBECED",
    d: "M18 32c7.18 0 13-.895 13-2s-5.82-2-13-2-13 .895-13 2 5.82 2 13 2",
    opacity: 0.6
  })));
};
export default SvgCarbonAvoidanceLogo;